import { IApplicationState } from '../../types/redux';

export function selectBrokerConsultantBannerButtonText(state: IApplicationState) {
  return state.config.brokerConsultantBannerButtonText ?? 'К заявке';
}
